/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect } from 'react';
import { useKlarnaContext } from '../KlarnaPaymentWrapper/KlarnaContext';

const KlarnaPaymentScript = () => {
    const { setScriptLoaded } = useKlarnaContext();

    useEffect(() => {
        if (typeof window !== 'undefined' && !document.querySelector('#klarna-payment-script')) {
            const script = document.createElement('script');
            script.id = 'klarna-payment-script';
            script.async = true;
            script.onload = () => setScriptLoaded(true);
            script.src = 'https://x.klarnacdn.net/kp/lib/v1/api.js';
            document.body.appendChild(script);
        } else {
            setScriptLoaded(true);
        }
    }, []);

    return null;
};

export default KlarnaPaymentScript;
